<!-- Overlay to close tray when clicking outside -->
<div
	class="tray-overlay"
	*ngIf="isOpen"
	(click)="onOverlayClick()"
></div>

<!-- Slide-out tray container -->
<div class="tray-container" [class.open]="isOpen">
	<div class="tray-header">
		<span class="tray-title">{{ title }}</span>
		<button mat-icon-button (click)="onCloseClick()" class="tray-close-btn">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="tray-content">
		<ng-content></ng-content>
	</div>
</div>
